import timer from './timer.reducer';

export default timer;


// WEBPACK FOOTER //
// src/main/components/timer/store/reducers/index.js